import makeApiCall from "./axiosIndex";

const sequenceApis = {
    createSequence: (data: any): Promise<any> => makeApiCall<any>({
        method: "post",
        url: "/buyer/createSequence",
        data
    }),
    fetchSequence: (): Promise<any> => makeApiCall<any>({
        method: "get",
        url: "/buyer/fetchSequence"
    }),
    fetchSequenceById: (id: any): Promise<any> => makeApiCall<any>({
        method: "get",
        url: "/buyer/fetchSequenceById",
        params: { deptId: id }
    }),
    updateSequenceById: (id: any, data: any): Promise<any> => makeApiCall<any>({
        method: "put",
        url: "/buyer/updateSequenceById",
        params: { id },
        data
    }),
    updateSequenceStatusById: (id: any): Promise<any> => makeApiCall<any>({
        method: "put",
        url: "/buyer/updateSequenceStatusById",
        params: { id },
    }),
    deleteSequenceById: (id: any): Promise<any> => makeApiCall<any>({
        method: "delete",
        url: "/buyer/deleteSequenceById",
        params: { id }
    })
};
export default sequenceApis
